export const getLocales = (): string[] =>
  (process.env.LOCALES
    ? process.env.LOCALES.replace(/\s/gm, '').split(',')
    : undefined) || ['en', 'nl'];
